import React, { useState, useEffect } from "react";
import MainDashboardLayout from "../../../Layout/MainDashboardLayout";
import GRISidebar from "../../../Layout/GRISidebar";
import styles from "../../../styles/gri/general.module.css";
import {
  Box,
  Button,
  Alert,
  Snackbar,
  RadioGroup,
  FormControl,
  Radio,
  FormControlLabel,
} from "@mui/material";
import EastIcon from "@mui/icons-material/East";
import { put, get } from "../../../utils/api";
import { useNavigate, useParams } from "react-router-dom";
import SectionHeading from "../GRI300/GRI308/SectionHeading";
import CustomTextField from "../GRI300/GRI308/CustomTextField";
import ReviewBox from "../../../Components/Common/ReviewBox";
import { currentYear } from "../../../utils/generateYearRanges";

const GRI411 = ({ hide }) => {
  const navigate = useNavigate();
  const { id } = useParams();
  const [disabled, setDisabled] = useState(false);
  const [errors, setErrors] = useState({});
  const [snackOpen, setSnackOpen] = useState({
    open: false,
    message: "",
    severity: "",
  });
  const [formData, setFormData] = useState({
    indigenousRightsViolationIncidents: "",
    reviewOrganization: true,
    remediationPlans: true,
    remediationPlansImplemented: { status: true, remarks: "" },
    noLongerSubject: { status: true, remarks: "" },
  });
  const [griReview, setGriReview] = useState(() => JSON.parse(localStorage.getItem("griReview")));

  useEffect(() => {
    const handleStorage = () => {
      setGriReview(JSON.parse(localStorage.getItem("griReview")));
    };
    window.addEventListener("storage", handleStorage);
    return () => window.removeEventListener("storage", handleStorage);
  }, []);

  useEffect(() => {
    setGriReview(JSON.parse(localStorage.getItem("griReview")));
  }, []);

  const handleBooleanChange = (field) => (event) => {
    const value = event.target.value === "yes"; // Convert to boolean
    setFormData((prev) => ({
      ...prev,
      [field]: value,
    }));
  };

  const handleRadioChange = (event, section) => {
    const statusValue = event.target.value === "yes"; // Convert to boolean
    setFormData((prev) => ({
      ...prev,
      [section]: {
        ...prev[section],
        status: statusValue,
      },
    }));
  };

  const handleRadioChange1 = (event) =>
    handleRadioChange(event, "remediationPlansImplemented");
  const handleRadioChange2 = (event) =>
    handleRadioChange(event, "noLongerSubject");
  // const handleRadioChange3 = (event) => handleRadioChange(event, "remediationPlans");

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await get(`/gri/get?type=GRI400&Id=${id}`);
        if (response?.data?.data?.year < currentYear - 1)
          setDisabled(true);
        const data = response.data.data.GRI400?.rightsOfIndigenous || {};
        setFormData({
          indigenousRightsViolationIncidents:
            data.indigenousRightsViolationIncidents || "",
          reviewOrganization: data.reviewOrganization || false,
          remediationPlans: data.remediationPlans || false,
          noLongerSubject: {
            remarks: data.noLongerSubject?.remarks || "",
            status: Boolean(data.noLongerSubject?.status || ""),
          },
          remediationPlansImplemented: {
            remarks: data.remediationPlansImplemented?.remarks || "",
            status: Boolean(data.remediationPlansImplemented?.status || ""),
          },
        });
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    fetchData();
  }, []);

  const handleNestedInputChange = (section, field, value) => {
    setFormData((prev) => ({
      ...prev,
      [section]: {
        ...prev[section],
        [field]: value,
      },
    }));

    // Remove error for the specific field
    if (value.trim()) {
      setErrors((prev) => ({ ...prev, [field]: "" }));
    }
  };

  const handleInputChange = (field, value) => {
    setFormData((prev) => ({ ...prev, [field]: value }));
    setErrors((prev) => ({ ...prev, [field]: "" }));
  };

  const validateForm = () => {
    let newErrors = {};
    let formIsValid = true;

    if (formData.remediationPlansImplemented.status) {
      // Validate `days` field
      if (!formData.remediationPlansImplemented.remarks) {
        newErrors.remarks = "This field is required";
        formIsValid = false;
      }
    }

    if (formData.noLongerSubject.status) {
      // Validate `days` field
      if (!formData.noLongerSubject.remarks) {
        newErrors.remarks = "This field is required";
        formIsValid = false;
      }
    }

    // if (!formData.indigenousRightsViolationIncidents) {
    //   newErrors.indigenousRightsViolationIncidents = "This field is required";
    //   formIsValid = false;
    // } else
    if (isNaN(formData.indigenousRightsViolationIncidents)) {
      newErrors.indigenousRightsViolationIncidents =
        "Please enter a valid numeric value";
      formIsValid = false;
    } else if (formData.indigenousRightsViolationIncidents < 0) {
      newErrors.indigenousRightsViolationIncidents =
        "Please enter a valid numeric value";
      formIsValid = false;
    }

    setErrors(newErrors);
    return formIsValid;
  };

  const handleSubmit = async () => {
    if (!disabled) {
      if (!validateForm()) return; // Validate form before submission

      const payload = {
        type: "GRI400",
        rightsOfIndigenous: {
          indigenousRightsViolationIncidents:
            formData.indigenousRightsViolationIncidents,
          reviewOrganization: formData.reviewOrganization,
          remediationPlans: formData.remediationPlans,
          remediationPlansImplemented: formData.remediationPlansImplemented,
          noLongerSubject: formData.noLongerSubject,
        },
        submitted411: true,
      };

      try {
        const token = sessionStorage.getItem("token");
        if (!token) {
          throw new Error("Authentication token is missing.");
        }
        await put(`/gri/update?Id=${id}`, payload);
        navigate(`/gri/gri400/413-1/${id}`);
      } catch (error) {
        setSnackOpen({
          open: true,
          message: "Error updating data. Please try again.",
          severity: "error",
        });
      }
    } else {
      navigate(`/gri/gri400/413-1/${id}`);
    }
  };

  const renderContent = ({ hide }) => (
    <>
      {/* <SectionHeading text="2-1 Activities, value chain and other business relationships" /> */}
      <p
        className={styles.section_heading}
        style={{ marginBottom: hide ? "-1rem" : "0" }}
      >
        411 : Rights of Indigenous People
      </p>
      <p
        className={styles.main_heading}
        style={{ marginBottom: hide ? "-1.5rem" : "0" }}
      >
        411-1 : IncIdents of violations involving rights of indigenous peoples
      </p>
      <Box>
        <SectionHeading
          text="a. Provide the number of incidents involving violations of the rights of indigenous peoples were identified during the reporting period?"
          sx={{ marginTop: "2rem" }}
        />

        <Box sx={{ width: "40%" }}>
          <CustomTextField
            value={formData.indigenousRightsViolationIncidents}
            onChange={(e) =>
              handleInputChange(
                "indigenousRightsViolationIncidents",
                e.target.value
              )
            }
            error={errors.indigenousRightsViolationIncidents}
            placeholder={"Number of Incidents"}
            helperText={errors.indigenousRightsViolationIncidents}
            disabled={disabled}
          />
        </Box>
        <SectionHeading
          text="b. What is the current status of the incidents related to violations of indigenous peoples' rights, and what actions have been taken? Please indicate:"
          sx={{ marginBottom: "-1rem" }}
        />
        <Box sx={{ marginLeft: "1rem", marginTop: "1rem" }}>
          <Box sx={{ marginTop: "1.5rem" }}>
            <SectionHeading text="i. Whether the incident has been reviewed by the organization." />
          </Box>
          <FormControl sx={{ marginTop: "-1rem", marginLeft: "1rem" }}>
            <RadioGroup
              row
              value={formData.reviewOrganization ? "yes" : "no"}
              onChange={handleBooleanChange("reviewOrganization")}
              disabled={disabled}
            >
              <FormControlLabel
                value="yes"
                control={<Radio disabled={disabled} />}
                label="Yes"
              />
              <FormControlLabel
                value="no"
                control={<Radio disabled={disabled} />}
                label="No"
              />
            </RadioGroup>
          </FormControl>

          <SectionHeading
            text="ii.  If remediation plans are being implemented."
            sx={{ marginTop: "1.5rem", marginBottom: "-1rem" }}
          />
          <FormControl sx={{ margin: "1rem" }}>
            <RadioGroup
              row
              value={formData.remediationPlans ? "yes" : "no"}
              onChange={handleBooleanChange("remediationPlans")}
              disabled={disabled}
            >
              <FormControlLabel
                value="yes"
                control={<Radio disabled={disabled} />}
                label="Yes"
              />
              <FormControlLabel
                value="no"
                control={<Radio disabled={disabled} />}
                label="No"
              />
            </RadioGroup>
          </FormControl>

          <SectionHeading
            text="iii. Whether remediation plans have been implemented, and if so, provide details of the results reviewed through routine internal management review processes."
            sx={{ marginBottom: "-1rem" }}
          />
          <FormControl sx={{ margin: "1rem" }}>
            <RadioGroup
              row
              value={formData.remediationPlansImplemented.status ? "yes" : "no"}
              onChange={(e) =>
                handleRadioChange1(e, "remediationPlansImplemented")
              }
              disabled={disabled}
            >
              <FormControlLabel
                value="yes"
                control={<Radio disabled={disabled} />}
                label="Yes"
              />
              <FormControlLabel
                value="no"
                control={<Radio disabled={disabled} />}
                label="No"
              />
            </RadioGroup>
          </FormControl>
          {formData.remediationPlansImplemented.status && (
            <CustomTextField
              value={formData.remediationPlansImplemented.remarks}
              onChange={(e) =>
                handleNestedInputChange(
                  "remediationPlansImplemented",
                  "remarks",
                  e.target.value
                )
              }
              error={errors.remarks}
              helperText={errors.remarks}
              disabled={disabled}
            />
          )}

          <SectionHeading
            text="iv. If the incident is no longer subject to action."
            sx={{ marginTop: "2rem", marginBottom: "-1rem" }}
          />
          <FormControl sx={{ margin: "1rem" }}>
            <RadioGroup
              row
              value={formData.noLongerSubject.status ? "yes" : "no"}
              onChange={(e) => handleRadioChange2(e, "noLongerSubject")}
              disabled={disabled}
            >
              <FormControlLabel
                value="yes"
                control={<Radio disabled={disabled} />}
                label="Yes"
              />
              <FormControlLabel
                value="no"
                control={<Radio disabled={disabled} />}
                label="No"
              />
            </RadioGroup>
          </FormControl>
          {formData.noLongerSubject.status && (
            <CustomTextField
              value={formData.noLongerSubject.remarks}
              onChange={(e) =>
                handleNestedInputChange(
                  "noLongerSubject",
                  "remarks",
                  e.target.value
                )
              }
              error={errors.remarks}
              helperText={errors.remarks}
              disabled={disabled}
            />
          )}
        </Box>
      </Box>

      <Box sx={{ display: "flex", flexDirection: "column" }}>
        {/* Submit Button */}

        {/* Snackbar for success/error messages */}
        <Snackbar
          open={snackOpen.open}
          message={snackOpen.message}
          autoHideDuration={3000}
          anchorOrigin={{ vertical: "top", horizontal: "center" }}
          onClose={() => setSnackOpen({ ...snackOpen, open: false })}
        >
          <Alert
            severity={snackOpen.severity}
            variant="filled"
            sx={{ width: "100%" }}
          >
            {snackOpen.message}
          </Alert>
        </Snackbar>
      </Box>
    </>
  );

  return (
    <>
      {!hide ? (
        <MainDashboardLayout sidebar={<GRISidebar />}>
          {renderContent({ hide })}

          <>
            {!griReview ? (
              <Box sx={{ ml: "1rem", width: "98%" }}>
                <ReviewBox url={"/gri"} handleSubmit={handleSubmit} />
              </Box>
            ) : (
              <Box textAlign="right" sx={{ mt: 3 }}>
                <Button
                  variant="contained"
                  sx={{
                    bgcolor: "#1C486B",
                    textTransform: "none",
                    mt: 3,
                    mb: 5,
                  }}
                  onClick={handleSubmit}
                >
                  Save & Continue <EastIcon sx={{ ml: 2 }} />
                </Button>
              </Box>
            )}
          </>
        </MainDashboardLayout>
      ) : (
        renderContent({ hide })
      )}
    </>
  );
};

export default GRI411;
